import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledWrap = styled(Box)(() => {
  return {
    height: 300,
  };
});

const LocationMap = () => {
  return (
    <StyledWrap
      dangerouslySetInnerHTML={{
        __html: `<iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d160.76771997044497!2d24.034791874589732!3d49.85591865674245!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1suk!2sua!4v1743337452473!5m2!1suk!2sua" width="100%" height="350px" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>`,
      }}
      mb={10}
      mt={2}
    ></StyledWrap>
  );
};

export default LocationMap;
